// extracted by mini-css-extract-plugin
module.exports = {"container":"SigningMenu_container__3hhmr"};